import React from 'react';
import { Squares2X2Icon, ListBulletIcon } from '@heroicons/react/24/outline';

export function ViewToggle({ view, onViewChange }) {
  return (
    <div className="flex items-center space-x-2 bg-white rounded-lg shadow-sm p-1">
      <button
        onClick={() => onViewChange('list')}
        className={`p-2 rounded ${
          view === 'list'
            ? 'bg-blue-100 text-blue-600'
            : 'hover:bg-gray-100 text-gray-600'
        }`}
      >
        <ListBulletIcon className="w-5 h-5" />
      </button>
      <button
        onClick={() => onViewChange('grid')}
        className={`p-2 rounded ${
          view === 'grid'
            ? 'bg-blue-100 text-blue-600'
            : 'hover:bg-gray-100 text-gray-600'
        }`}
      >
        <Squares2X2Icon className="w-5 h-5" />
      </button>
    </div>
  );
}